import angular from 'angular';
import addressHistoryModal from './addressHistoryModal';
import './style.scss';

export default angular
  .module('components.addressHistoryModal', [])
  .component('addressHistoryModal', addressHistoryModal).name;
